import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';
import { BackofficeService } from 'src/app/services/backoffice.service';
import { catchError } from 'rxjs';
import { ConfirmationModalComponent } from 'src/app/common/confirmation-modal/confirmation-modal.component';
import { CancelResponse } from 'src/app/model/cancel-response';
import { ConfirmationModalInputParams } from 'src/app/model/confirmation-modal-input-param';
import { LoggingService } from 'src/app/services/logging.service';
import { CancelTransactionLoadResponse } from 'src/app/model/cancel-transaction-load-response';
import { CancelTransactionRequest } from 'src/app/model/cancel-transaction-request';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'cancel-transaction',
  templateUrl: './cancel-transaction.component.html',
  styleUrls: ['./cancel-transaction.component.scss']
})
export class CancelTransactionComponent implements OnInit {
  @ViewChild('modalReference') modalRef: ElementRef<any> | undefined;
  @Output() cancelResponseCallback = new EventEmitter<CancelResponse>();

  public msg = messages;
  public cancellationReasonList: MultiSelectorDetails[] = [];
  public cancellationReason: string = '';
  public selectCancellationReason = false;
  public selectRefrenceId = false;
  public rspReferenceID: string = '';
  public notes: string = '';
  public keepChargesOI: boolean = true;
  public keepChargesOiDisabled: boolean = false;
  public rspReferenceIdOptional: boolean = true;
  public transmitToOI: boolean = true;
  public emailOI: boolean = false;
  public cancellationTitle: string = '';
  private selectedTransactions: any[] = [];
  private cancelResponse: CancelResponse = new CancelResponse();
  private isBulkCancellation: boolean = false;
  private isCancelPaid: boolean = false;
  private selectedTransaction: any;
  private babOI ="SABAB01";
  private babReasonId = '145';
  public noteMaxLengthValid = "valid";

  @ViewChild('cancellationReasonRefrence') cancellationReasonRef!: ElementRef<any>;
  @ViewChild('rspReferenceIDReference') rspReferenceIDRef!: ElementRef<any>;
  @ViewChild('notesTextAreaReference') notesTextAreaRef!: ElementRef<any>;
  @ViewChild('rspKeepChargesOiReference') rspKeepChargesOiRef!: ElementRef<any>;
  @ViewChild(ConfirmationModalComponent)
  private confirmationModalComponent!: ConfirmationModalComponent;

  constructor(private backofficeService: BackofficeService, private catalogService: CatalogService, private loggingService: LoggingService, private commonService : CommonService) { }

  ngOnInit(): void {
    this.selectedTransactions = [];
    this.selectedTransaction = {};
  }

  public loadCancelModel(transactions: any[], transaction: any, isBulkCancellation: boolean = false, isCancelPaid: boolean = false) {
    this.isBulkCancellation = isBulkCancellation;
    this.isCancelPaid = isCancelPaid;
    this.noteMaxLengthValid = "valid";

    if (isCancelPaid) {
      this.cancellationTitle = this.msg.ProcessUnpaidTransactions.CancelPaidTransactionTitle;
    }
    else {
      this.cancellationTitle = this.msg.ProcessUnpaidTransactions.CancelTransactionTitle;
    }

    if (isBulkCancellation) {
      this.selectedTransactions = transactions;
      this.bulkCancellationValidity(this.selectedTransactions);
    }
    else {
      this.selectedTransaction = transaction;
      this.cancelTransactionOnLoad(transaction, isCancelPaid);
    }

  }

  closeCancelModal() {
    this.loggingService.logCustomEvent("Close Cancel Transaction Modal");
    this.selectCancellationReason = false;
    this.selectRefrenceId = false;
    this.modalRef?.nativeElement.closeModal();
  }

  clearCancellationReason() {
    this.cancellationReason = '';
  }

  setCancellationReason($event: any) {
    this.cancellationReason = $event.detail?.selectedItemArray.map((x: MultiSelectorDetails) => x.id);
    this.selectCancellationReason = false;
    this.cancellationReasonRef?.nativeElement.closeSelectionPanel();
  }

  setRspReferenceID($event: any) {
    this.rspReferenceID = $event.detail.value;
    this.selectRefrenceId = false;
  }

  clearRspReferenceID() {
    this.rspReferenceID = "";
  }

  setNotes($event: any) {
    this.notes = $event.detail.value;
    if (this.notes?.length > 200 ) {
      this.noteMaxLengthValid = 'invalid';
    }else {
      this.noteMaxLengthValid = "valid";      
    }
  }

  setKeepChargesOI($event: any) {
    this.keepChargesOI = $event.detail.isChecked;
  }

  setTransmitToOI($event: any) {
    this.transmitToOI = $event.detail.isChecked;
  }

  setEmailOI($event: any) {
    this.emailOI = $event.detail.isChecked;
  }

  private OpenCancelPopup = (): void => {
    this.cancellationReason = '';
    this.rspReferenceID = '';
    this.notes = '';
    this.keepChargesOI = true;
    this.keepChargesOiDisabled = false;
    this.rspReferenceIdOptional = true;
    this.transmitToOI = true;
    this.emailOI = false;
    this.cancellationReasonRef?.nativeElement.resetSelectMenu();
    this.rspReferenceIDRef.nativeElement.value = '';
    this.notesTextAreaRef.nativeElement.value = '';
    this.selectCancellationReason = false;
    this.selectRefrenceId = false;
    this.getCancellationReason();
    this.modalRef?.nativeElement.openModal();
  }

  resetForm() {
    this.cancellationReason = '';
    this.rspReferenceID = '';
    this.notes = '';
    this.keepChargesOI = true;
    this.transmitToOI = true;
    this.emailOI = false;
    this.noteMaxLengthValid = "valid"
  }

  private getCancellationReason() {
    this.catalogService.getCancellationReason(1).subscribe(response => {
      this.cancellationReasonList = response.data.map(x => <MultiSelectorDetails><unknown>{
        id: x.cancellationId,
        description: [x.name]
      });
    })
  }

  openConfirmation() {
    this.loggingService.logCustomEvent("Open Cancel Transaction Modal");
    this.modalRef?.nativeElement.closeModal();
    const that = this
    let param: ConfirmationModalInputParams = {
      msg: this.msg.ProcessUnpaidTransactions.ConfirmBulkCancel,
      yesFunc: that.processBulkCancel.bind(this)
    }
    this.confirmationModalComponent.confirm(param);
  }

  public processCancellation() {
    if (this.notes?.length > 200) {
      this.noteMaxLengthValid = 'invalid';
    } 
    else {
      if (this.isBulkCancellation) {
        this.processBulkCancel();
      }
      else {
        if (this.selectedTransaction?.oiId == this.babOI && this.cancellationReason != this.babReasonId) {
          let param: ConfirmationModalInputParams = {
            msg: this.msg.ProcessUnpaidTransactions.SelectBabCancellationReason,
            yesFunc: this.cancelTransaction.bind(this),
            noFunc: this.closeCancelModal.bind(this)
          }
          this.confirmationModalComponent.confirm(param);
        }
        else {
          this.cancelTransaction();
        }
      }
    }
  }

  private cancelTransaction() {
    if (this.validateCancel()) {     

      let request: CancelTransactionRequest = {
        cancellationId: Number(this.cancellationReason),
        rspReferenceId: this.rspReferenceID,
        notes: this.notes,
        keepChargesOI: this.keepChargesOI,
        transmitToOI: this.transmitToOI,
        emailOI: this.emailOI,
        isPaid: this.isCancelPaid,
        oiId: this.selectedTransaction?.oiId,
        invoiceId: this.selectedTransaction?.invoiceId,
        xbcUserId: '',
        mainBranchId: this.selectedTransaction?.mainBranchId
      }

      this.backofficeService.cancelTransaction(request).subscribe(response => {
        this.loggingService.logCustomEvent(`Cancel transaction successful for ${this.selectedTransaction?.oiId} - ${this.selectedTransaction?.invoiceId}.`);
        this.cancelResponseCallback.emit();
        this.closeCancelModal();
      });
    }
  }

  private validateCancel():boolean {
    let result = true;
    if (this.cancellationReason == '') {
      this.selectCancellationReason = true;
      result = false;
    }
    if (!this.rspReferenceIdOptional && this.rspReferenceID.trim() == '') {
      this.selectRefrenceId = true;
      result = false;
    }

    return result;
  }

  private processBulkCancel() {
    if (this.selectedTransactions.length > 0) {
      if (this.cancellationReason == '') {
        this.selectCancellationReason = true;
      } 
      else {
        let askConfirmation = false;
        this.selectedTransactions.forEach((item) => {
          if (item.oiId == this.babOI && this.cancellationReason != this.babReasonId) {
            askConfirmation = true;
          }
        });

        if (askConfirmation) {
          let param: ConfirmationModalInputParams = {
            msg: this.msg.ProcessUnpaidTransactions.SelectBabCancellationReason,
            yesFunc: this.bulkCancel.bind(this),
            noFunc: this.closeCancelModal.bind(this)
          }
          this.confirmationModalComponent.confirm(param);
        }
        else {
          this.bulkCancel();
        }
      }
    } 
    else {
      this.cancelResponse.SuccessOrError = false;
      this.cancelResponse.message = this.msg.ProcessUnpaidTransactions.SelectTransactions;
      this.cancelResponseCallback.emit(this.cancelResponse);
    }
  }

  public bulkCancel() {
    let transactions: CancelTransactionRequest[] = [];

    this.selectedTransactions.forEach((item) => {  
      let transaction: CancelTransactionRequest = {
        cancellationId: Number(this.cancellationReason),
        rspReferenceId: this.rspReferenceID,
        notes: this.notes,
        keepChargesOI: this.keepChargesOI,
        transmitToOI: this.transmitToOI,
        emailOI: this.emailOI,
        isPaid: this.isCancelPaid,
        oiId: item.oiId,
        invoiceId: item.transactionId,
        xbcUserId: '',
        mainBranchId: item.rspId?.value
      }

      transactions.push(transaction)
    });

    this.backofficeService.processBulkCancellation(transactions)
      .pipe(
        catchError((err) => {
          this.closeCancelModal();
          this.cancelResponse.data = err?.error?.data;
          this.cancelResponse.message = err?.message;
          this.cancelResponseCallback.emit(this.cancelResponse);
          return err;
        })
      )
      .subscribe(res => {
        this.loggingService.logCustomEvent("Process Cancel Transaction(s)");
        this.closeCancelModal();
        this.cancelResponse.data = (<any>res).data.filter((x: any) => !x.isSuccess);
        this.cancelResponseCallback.emit(this.cancelResponse);
      });
  }

  public bulkCancellationValidity(selectedTransactions: any[]) {
    if (selectedTransactions.length > 0) {
      if (selectedTransactions.filter(t => t.oiId == this.babOI).length > 0) {

        let param: ConfirmationModalInputParams = {
          msg: this.msg.ProcessUnpaidTransactions.ConfirmBABTransaction,
          yesFunc: this.OpenCancelPopup
        }
        this.confirmationModalComponent.confirm(param);
      }
      else {
        this.OpenCancelPopup();
      }
    } else {
      this.cancelResponse.SuccessOrError = false;
      this.cancelResponse.message = this.msg.ProcessUnpaidTransactions.SelectTransactions;
      this.cancelResponseCallback.emit(this.cancelResponse);
    }
  }

  private cancelTransactionOnLoad(selectedTransaction: any, isPaid: boolean) {
    if (selectedTransaction != null) {

      this.backofficeService.getCancelTransactionPreLoadInformation(selectedTransaction?.oiId, selectedTransaction?.invoiceId, selectedTransaction?.mainBranchId, isPaid)
        .subscribe(response => {
          if (response?.data != null) {
            let loadData = response?.data;
            this.SetCancelPopup(loadData, selectedTransaction);
          }
        });
    } else {
      this.cancelResponse.SuccessOrError = false;
      this.cancelResponse.message = this.msg.ProcessUnpaidTransactions.SelectTransactions;
      this.cancelResponseCallback.emit(this.cancelResponse);
    }
  }

  public SetCancelPopup(loadData: CancelTransactionLoadResponse, selectedTransaction: any) {
    if (loadData?.message == null || loadData?.message == '') {
      this.OpenCancelPopup();

      if (selectedTransaction?.recipientFlagId == 'H') {
        this.keepChargesOiDisabled = true;
      }

      this.rspReferenceIdOptional = !loadData?.isReferenceIdMandatory;
    }
    else {
      this.cancelResponse.SuccessOrError = false;
      this.cancelResponse.message = loadData?.message;
      this.cancelResponseCallback.emit(this.cancelResponse);
    }
  }

}